import { Button, Flex, Image, Input, Stack, Text } from "@chakra-ui/react";
import React, { useRef, useState } from "react";
import Modal from "react-modal";
import CloseButton from "../images/close.png";
import "../pages/ContentFrame.css";
import { deleteCertification, editCertification } from "../services/CertificationAPI";

const CertificationAdminCard = (props) => {
    Modal.setAppElement("#root");
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [value, setValue] = useState(props.title); // 인증서명
    const handleChange = (event) => setValue(event.target.value);

    const [isEditModalOpen, setIsEditModalOpen] = useState(false);

    const inputRef = useRef(null);

    const [file, setFile] = useState(null); // 파일 임시 저장 변수
    const [imageName, setImageName] = useState(props.image.split("/")[4]);
    const [imgBase64, setImgBase64] = useState(props.image); // 파일 base64 (이미지 미리보기를 위한 목적)

    const handleClick = () => {
        inputRef.current.click();
    };

    const fileChange = (event) => {
        setFile(event.target.files[0]);
        setImgBase64([]);
        setImageName(event.target.files[0].name);

        for (var i = 0; i < event.target.files.length; i++) {
            if (event.target.files[i]) {
                let reader = new FileReader();
                reader.readAsDataURL(event.target.files[i]); // 1. 파일을 읽어 버퍼에 저장.
                // 파일 상태 업데이트
                reader.onloadend = () => {
                    // 2. 읽기가 완료되면 아래코드가 실행.
                    const base64 = reader.result;
                    if (base64) {
                        // 문자 형태로 저장
                        var base64Sub = base64.toString();
                        // 배열 state 업데이트
                        setImgBase64((imgBase64) => [...imgBase64, base64Sub]);
                    }
                };
            }
        }
    };

    const deleteFile = (file) => {
        deleteCertification(file, props.id).then(() => {
            alert("인증서가 삭제되었습니다.");
            setIsModalOpen(false);
            props.setUpdateState(Math.random());
        });
    };

    const editFile = () => {
        editCertification(file, props.id, value).then(() => {
            alert("인증서 정보가 수정되었습니다!");
            setIsEditModalOpen(false);
            props.setUpdateState(Math.random());
        });
    };

    const openModifyModal = () => {
        setIsModalOpen(false);
        setIsEditModalOpen(true);
    };

    const clearState = () => {
        setValue(props.title);
        setImgBase64(props.image);
        setImageName(props.image.split("/")[4]);
        setIsEditModalOpen(false);
    };

    const confirmForm = () => {
        if (value === "" || isSpaceWord(value)) {
            alert("인증서명을 입력해주세요! 공백은 인정되지 않습니다.");
        } else {
            editFile();
        }
    };

    const isSpaceWord = (word) => {
        // 공백으로만 이루어진 경우 체크
        const removedWord = word.replace(/\s/g, "");
        if (removedWord === "") {
          return true;
        }
        return false;
      };

    const questionBeforeDelete = () => {
        if (window.confirm("정말 삭제하시겠습니까?")) {
            deleteFile();
        } else {
            alert("인증서 삭제를 취소합니다.");
        }
    };

    return (
        <>
            <div className="certification_card" onClick={() => setIsModalOpen(true)}>
                <img className="certification_img" src={props.image} />
                <div className="certification_title">{props.title}</div>
            </div>

            <Modal
                isOpen={isModalOpen}
                style={{
                    content: {
                        width: "400px",
                        height: "500px",
                        margin: "auto",
                        marginTop: "80px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    },
                }}
                onRequestClose={() => {
                    setIsModalOpen(false);
                }}
            >
                <Flex direction="column">
                    <Image width="10px" mt="-20px" ml="355px" src={CloseButton} onClick={() => setIsModalOpen(false)} />
                    <Stack direction="column" alignItems="center">
                        <Text fontSize="5xl" as="b" mb="40px" mt="10px">
                            인증서 관리
                        </Text>
                        <img style={{ height: "250px" }} src={props.image} />

                        <Flex mt="50px" mb="10px">
                            <Button colorScheme="green" fontSize="3xl" px="10px" py="20px" onClick={openModifyModal}>
                                편집
                            </Button>
                            <Button colorScheme="red" fontSize="3xl" px="10px" py="20px" onClick={questionBeforeDelete} ml="5px">
                                삭제
                            </Button>
                        </Flex>
                    </Stack>
                </Flex>
            </Modal>

            <Modal
                isOpen={isEditModalOpen}
                style={{
                    content: {
                        width: "400px",
                        height: "550px",
                        margin: "auto",
                        marginTop: "80px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    },
                }}
            >
                <Flex alignItems="center" direction="column">
                    <Text fontSize="5xl" as="b" mb="30px" mt="10px">
                        인증서 수정
                    </Text>

                    <Flex alignContent="center" mb="10px" mt="10px">
                        <Text fontSize="2xl" mt="-3px" width="100px">
                            인증서명:
                        </Text>
                        <Input htmlSize={15} defaultValue={value} onChange={handleChange} size="sm" />
                    </Flex>
                    <Image mt="10px" mb="10px" height="250px" src={imgBase64} alt="미리보기" />
                    <Flex mb="8px" mt="2px">
                        <Input width="150px" value={imageName} readOnly />
                        <Button
                            ml="5px"
                            width="80px"
                            fontSize="xl"
                            height="25px"
                            size="md"
                            colorScheme="red"
                            onClick={handleClick}
                        >
                            파일 선택
                        </Button>
                        <input
                            style={{ display: "none" }}
                            ref={inputRef}
                            type="file"
                            accept="image/*"
                            onChange={fileChange}
                        />
                    </Flex>

                    <Flex mt="30px" mb="10px">
                        <Button fontSize="3xl"
              px="10px"
              py="17px" colorScheme="red" mr={3} onClick={() => clearState()}>
                            닫기
                        </Button>
                        <Button 
                        fontSize="3xl"
                        px="10px"
                        py="17px" 
                        colorScheme="gray" onClick={() => confirmForm()}>
                            편집
                        </Button>
                    </Flex>
                </Flex>
            </Modal>
        </>
    );
};

export default CertificationAdminCard;
